import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/company', pathMatch: 'full' },
  { path: '', children: [
      {
        path: 'company',
        loadChildren: () => import('./modules/companie/companie.module').then(m => m.CompanieModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'holding',
        loadChildren: () => import('./modules/holding/holding.module').then(m => m.HoldingModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'version',
        loadChildren: () => import('./modules/version/version.module').then(m => m.VersionModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'monitor',
        loadChildren: () => import('./modules/monitor/monitor.module').then(m => m.MonitorModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  },

  { path: '**', redirectTo: '/companie' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
